import PropTypes from 'prop-types';
import React from 'react';
import { MobileThumbnailList } from '../ThumbnailList';


const MobileStudyItem = ({
  date,
  description,
  numInstances,
  modalities,
  isActive,
  onClick,
  isExpanded,
  displaySets,
  activeDisplaySetInstanceUIDs,
  onClickThumbnail,
  onDoubleClickThumbnail,
  onClickUntrack,
  viewPreset = 'thumbnails',
  // onThumbnailContextMenu,
  ThumbnailMenuItems,
  StudyMenuItems,
  StudyInstanceUID,
}: withAppTypes) => {
  return (
    <MobileThumbnailList
      thumbnails={displaySets}
      activeDisplaySetInstanceUIDs={activeDisplaySetInstanceUIDs}
      onThumbnailClick={onClickThumbnail}
      onThumbnailDoubleClick={onDoubleClickThumbnail}
      onClickUntrack={onClickUntrack}
      viewPreset={viewPreset}
      // onThumbnailContextMenu={onThumbnailContextMenu}
      ThumbnailMenuItems={ThumbnailMenuItems}
    />
  );
};

MobileStudyItem.propTypes = {
  date: PropTypes.string.isRequired,
  description: PropTypes.string,
  modalities: PropTypes.string.isRequired,
  numInstances: PropTypes.number.isRequired,
  // trackedSeries: PropTypes.number,
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool,
  displaySets: PropTypes.array,
  activeDisplaySetInstanceUIDs: PropTypes.array,
  onClickThumbnail: PropTypes.func,
  onDoubleClickThumbnail: PropTypes.func,
  onClickUntrack: PropTypes.func,
  viewPreset: PropTypes.string,
  StudyMenuItems: PropTypes.func,
  StudyInstanceUID: PropTypes.string,
};

export { MobileStudyItem };
